"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoanStage = exports.UniversalLoanStatus = void 0;
/**
 * This is the status of the universal application.
 */
var UniversalLoanStatus;
(function (UniversalLoanStatus) {
    /**
     * Prefilled applications are partial applications that came from a 3rd party source (like GreenLyne)
     * but have not been saved or submitted
     */
    UniversalLoanStatus["PREFILLED"] = "PREFILLED";
    /**
     * These are newly entered applications that have not been picked up by a loan officer yet
     */
    UniversalLoanStatus["NEW"] = "NEW";
    /**
     * These are applications that have been picked up by a loan officer and are in progress of working them
     */
    UniversalLoanStatus["IN_PROGRESS"] = "IN_PROGRESS";
    /**
     * These are applications that have been closed or archieved.  The loan officer does not wish to see them
     * in any "active" listing.
     */
    UniversalLoanStatus["ARCHIVED"] = "ARCHIVED";
    /**
     * Submitted applications are ones that the customer has complete, and the loan officer has submitted
     * to the loan origination system
     */
    UniversalLoanStatus["SUBMITTED"] = "SUBMITTED";
})(UniversalLoanStatus = exports.UniversalLoanStatus || (exports.UniversalLoanStatus = {}));
/**
 * This is the stage of the universal application.
 */
var LoanStage;
(function (LoanStage) {
    LoanStage["PROSPECT"] = "PROSPECT";
    LoanStage["PROPOSAL"] = "PROPOSAL";
    LoanStage["APPLICATION"] = "APPLICATION";
    LoanStage["PROCESSING"] = "PROCESSING";
})(LoanStage = exports.LoanStage || (exports.LoanStage = {}));
